import { defineMessages } from '@transcend-io/internationalization';

export const useDownloadZipMessages = defineMessages(
  'privacy-center.hooks.useDownloadZip',
  {
    countsOnlyMessage: {
      defaultMessage:
        'We found {count} files that matched your identifier for the datapoint: {title}',
    },
  },
);
